import React from "react";

import { Page } from "components/page";
import AiSuggestions from "components/ai-suggestions/ai-suggestions";

export const Suggested = () => {
  const [isSending, setIsSending] = React.useState(false);

  return (
    <Page
      title="Content Generated For You"
      description="Here are posts generated for you. Post them or use them as
      inspiration. Refreshed every day."
      showLoadingBar={true}
      isLoadingFeature={isSending}
    >
      <AiSuggestions setIsLoading={setIsSending}/> 
    </Page>
  );
};

export default Suggested;
